'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getEmptyImage;
var emptyImage = void 0;
function getEmptyImage() {
	if (!emptyImage) {
		emptyImage = new Image();
		emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	}

	return emptyImage;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd-html5-backend/lib/getEmptyImage.js
// module id = 1057
// module chunks = 0